interface ICrossIconProps {
  onClick: () => void;
}

function CrossIcon({ onClick }: ICrossIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="4 4 16 16"
      width="16"
      height="16"
      onClick={onClick}
    >
      <path
        d="M19 6.41 17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
        fill="#4e55a2"
      />
    </svg>
  );
}

export default CrossIcon;
